import React from "react"
import styled from "styled-components"

import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa"

const Socials = () => {
  return (
    <Wrapper>
      <SocialLogos>
        <li>
          <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
            <FaFacebookF />
          </a>
        </li>
        <li>
          <a href="https://www.twitter.com" target="_blank" rel="noreferrer">
            <FaTwitter />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com" target="_blank" rel="noreferrer">
            <FaInstagram />
          </a>
        </li>
      </SocialLogos>
    </Wrapper>
  )
}

export default Socials

const Wrapper = styled.footer`
  position: absolute;
  width: 100%;
  bottom: 0;
`

const SocialLogos = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  font-size: 3rem;

  li {
    margin: 0 1vw;
  }

  a {
    color: #000;
  }
`
